module.exports = __webpack_public_path__ + "img/9k.311cdd47.jpg";